import React from 'react';
import ObjectDisplay from 'components/ObjectDisplay'

const filterDateFields = (value, key) => {
  return !["visitedAt","createdAt","updatedAt"].includes(key);
}

const Details = props => {
  return (
    <div>
      <h3>Recruiter Details</h3>
      <ObjectDisplay object={props.selected} filterFunc={filterDateFields}/>
    </div>
  );
};

export default Details



// WEBPACK FOOTER //
// ./src/components/recruiters/Details.jsx